import i18next from 'i18next'

export const defaultProcessingStages: string[] = [
  i18next.t('elements.loaders.loadingData'),
  i18next.t('elements.loaders.scanning'),
  i18next.t('elements.loaders.processing'),
  i18next.t('elements.loaders.preparing')
]
